<template>
<div class="section section-2 py-md-5">
  <div class="container">
    <h2 class="text-center section__title-principal mb-3">Estadísticas por país</h2>
    <div class="row">
      <div class="col">
        <div class="section__title">
          <h2>CORONAVIRUS <span>en Chile y {{ getCountryById(datos[1].id) || 'el mundo' }}</span></h2>
        </div>
          <div class="section__box-select--medium">
            <multiselect v-model="selectedCountry" track-by="value" label="text" placeholder="Seleccione un país" :options="countries" @input="changeCountry" selectLabel="Presione enter para seleccionar" deselectLabel="Presiones enter para remover" selectedLabel="Seleccionado" >
              <template slot="noResult">Sin resultados</template>
              <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.text }}</strong></template>
            </multiselect>
          </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="chart-selection">
        <div class="row">
          <div class="col-12 col-md-6 d-flex align-items-center">
            <div v-for="radioButton in radioButtons" :key="radioButton.value" class="custom-control custom-radio custom-control-inline">
              <input type="radio" class="custom-control-input" :id="radioButton.id" name="paises" @change="updateChart" v-model="selectedTipo" :value="radioButton.value" :checked="radioButton.checked">
              <label class="custom-control-label" :for="radioButton.id">{{ radioButton.name }}</label>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <date-picker v-model="range" @change="changeRange" valueType="format" range :disabledDate="disableDates" :clearable="false"/>
          </div>
        </div>
      </div>
      <div class="chart-line">
        <canvas ref="chart"></canvas>
      </div>
      <div class="chart-legend">
        <ul class="legend">
          <li><b>Chile:</b></li>
          <li class="legend__item legend__item--solid">Contagios</li>
          <li class="legend__item legend__item--dotted">Recuperados</li>
          <li class="legend__item legend__item--dashed">Fallecidos</li>
        </ul>
        <ul class="legend">
          <li><b>{{ getCountryById(datos[1].id) || 'Mundo' }}:</b></li>
          <li class="legend__item legend__item--solid">Contagios</li>
          <li class="legend__item legend__item--dotted">Recuperados</li>
          <li class="legend__item legend__item--dashed">Fallecidos</li>
        </ul>
      </div>
    </div>

   <div class="row">
      <div class="col-12 col-md-6">
        <grm-tasa label="Tasas Chile" :datos="this.datos[0]"/>
      </div>
      <div class="col-12 col-md-6">
        <grm-tasa :label="`Tasas en ${getCountryById(datos[1].id) || 'el mundo'}`" :datos="this.datos[1]"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/es';
import { chartDefaults, processData, disableDates } from '@/charts'
import { getCountries, getCountryData } from '@/api'
import GrmTasa from '../commons/GrmTasa'
export default {
  data() {
    return {
      chart: null,
      countries: [],
      range: [],
      selectedCountry: null,
      selectedTipo: 'contagios',
      datos: [
        { id: null, data: [] }, // Chile
        { id: null, data: [] }, // Otro país seleccionado
      ],
      radioButtons:[
        { id:'contagiosButtonMundo', value:'contagios', name:'Contagios', checked: true },
        { id:'recuperadosButtonMundo', value:'recuperados', name:'Recuperados' },
        { id:'fallecidosButtonMundo', value:'fallecidos', name:'Fallecidos' }
      ]
    }
  },

  methods: {
    async updateChart() {
      // ¿no hay grafico? no hacemos nada
      if (!this.chart) return false

      this.chart.data.datasets = []
      this.datos.forEach((dato, index) => {
        let datos = processData(this.selectedTipo, dato.data, index)
        this.chart.data.datasets.push({
          label: `${this.getCountryById(this.datos[index].id)} - ${this.selectedTipo}`,
          data: datos.data,
          borderDash: datos.borderDash,
          backgroundColor: datos.backgroundColor,
          borderColor: datos.borderColor(),
          pointBorderColor: datos.borderColor(),
          pointStyle: datos.pointStyle,
          pointHoverBorderColor: datos.borderColor(),
          pointBackgroundColor: datos.borderColor(),
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderWidth: 4,
          pointHoverRadius: 6,
          pointHitRadius: 10,
        })

        if (index === 0) {
          this.chart.data.labels = datos.labels
        }
      })

      this.chart.update()
    },

    async createChart() {
      const datos = processData(this.selectedTipo, this.datos[0].data)

      this.chart = new this.$chart(this.$refs.chart, {
        type: 'line',
        data: {
          labels: datos.labels,
          datasets:[{
            label: `Chile - ${this.selectedTipo}`,
            data: datos.data,
            backgroundColor: datos.backgroundColor,
            borderColor: datos.borderColor,
            pointBorderColor: datos.borderColor,
            pointHoverBorderColor: datos.borderColor,
            pointBackgroundColor: datos.borderColor,
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderWidth: 4,
            pointHoverRadius: 6,
            pointHitRadius: 10,
            labelColors: '#000'
          }],
        },
        options: chartDefaults.lineChart
      })
    },

    async changeCountry() {
      if (!this.selectedCountry) return false

      const datos = await getCountryData(this.selectedCountry.value, this.range)

      // Seteamos los datos del pais solicitado
      this.$set(this.datos[1], 'id', this.selectedCountry.value)
      this.$set(this.datos[1], 'data', datos.data)
      this.$set(this.datos[1], 'habitantes', datos.habitantes)
      this.$set(this.datos[1], 'ultimaActualizacion', datos.ultimaActualizacion)

      this.updateChart()
    },

    async changeRange() {
      let datos = await getCountryData(this.datos[0].id, this.range)

      // obtenemos la data de chile con las nuevas fechas
      // Este es el dato de la izquierda, las regiones
      this.$set(this.datos[0], 'data', datos.data)
      this.$set(this.datos[0], 'habitantes', datos.habitantes)
      this.$set(this.datos[0], 'ultimaActualizacion', datos.ultimaActualizacion)

      if (this.datos[1].id) {
        datos = await getCountryData(this.datos[1].id, this.range)

        // Seteamos los datos de la comuna solicitada
        this.$set(this.datos[1], 'data', datos.data)
        this.$set(this.datos[1], 'habitantes', datos.habitantes)
        this.$set(this.datos[1], 'ultimaActualizacion', datos.ultimaActualizacion)
      }

      this.updateChart()
    },

    getCountryById(id) {
      if (!id) return false

      if (this.countries) {
        for (let i = 0; i < this.countries.length; i++) {
          if (this.countries[i].value === id) {
            return this.countries[i].text
          }
        }
      }
      return ''
    },

    disableDates: disableDates
  },

  components: { DatePicker, GrmTasa },

  async mounted() {
    this.datos[0].id = 53
    const datos = await getCountryData(53, this.range)

    // Seteamos los datos de la comuna solicitada
    this.$set(this.datos[0], 'data', datos.data)
    this.$set(this.datos[0], 'habitantes', datos.habitantes)
    this.$set(this.datos[0], 'ultimaActualizacion', datos.ultimaActualizacion)

    this.countries = await getCountries()

    this.createChart()
  },

  created() {
    let date = new Date();
    date.setDate(date.getDate() - 30);
    this.range = [date.toISOString().slice(0,10), new Date().toISOString().slice(0,10)]
  }
}
</script>
